const SUPPORTED_PROVIDERS = new Set(['aws', 'gcp', 'alicloud'])

export function normalizeSlowLogExplorerProvider(
  provider?: string | null
): string {
  const normalized = String(provider ?? '')
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, '')

  switch (normalized) {
    case 'aws':
      return 'aws'
    case 'gcp':
    case 'google':
    case 'googlecloud':
      return 'gcp'
    case 'alicloud':
    case 'alibaba':
    case 'aliyun':
      return 'alicloud'
    default:
      return normalized
  }
}

export function isSlowLogExplorerProviderSupported(
  provider?: string | null
): boolean {
  return SUPPORTED_PROVIDERS.has(normalizeSlowLogExplorerProvider(provider))
}

export function getSlowLogExplorerAppPath(path = ''): string {
  const prefix = window.location.pathname.startsWith('/portal/')
    ? '/portal'
    : ''
  return `${prefix}/slow-log-explorer-app${path}`
}
